import Vue from 'vue';
import { MutationTree } from 'vuex';
import { AdministrationState, CtrLogItem } from '@/store/administration/types';

export const mutations: MutationTree<AdministrationState> = {
  setCtrIntegrationLog(state: AdministrationState, ctrLogItems?: CtrLogItem[]) {
    Vue.set(state, 'ctrIntegrationLog', ctrLogItems);
  }
};
